import { PerksSectionTemplate, PerksSectionTemplateProps } from "./template";

export const PerksSection = ({
  navigateToPage,
  addPlusIcon,
  currentLifestyleGroupName,
  currentLifestyleGroupResetDate,
}: PerksSectionTemplateProps): JSX.Element => {
  return (
    <PerksSectionTemplate
      navigateToPage={navigateToPage}
      addPlusIcon={addPlusIcon}
      currentLifestyleGroupName={currentLifestyleGroupName}
      currentLifestyleGroupResetDate={currentLifestyleGroupResetDate}
    />
  );
};
